"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "civita-d-antino": {
    "0973d048": [{
      "hkey": "aec21869",
      "slug": "civita-d-antino",
      "name": "Civita d'Antino",
      "primary": true,
      "skipSearch": false
    }],
    "de-blasis": [{
      "hkey": "aec21869",
      "slug": "civita-d-antino",
      "name": "Civita d'Antino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;